import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class IgnoreUserReportArgs {
  @Field(t => Int)
  docId!: number

  @Field(t => Int)
  type!: number

  @Field()
  ignore!: boolean
}
